/** @hidden */
export var DATA_DIALOGS_ID = 'data-windowid';
/** @hidden */
export var DEFAULT_DIALOGS_ZINDEX = 10002;
/** @hidden */
export var ZINDEX_DIALOGS_STEP = 2;
/** @hidden */
export var DIALOGS_SELECTOR = '.k-window:not(.k-dialog), .k-dialog-wrapper';